import axios from "axios";
import { tokenConfig } from "./auth";
import swal from "sweetalert";

import {
  GET_COMMON_STOCKTAKES,
  ADD_COMMON_STOCKTAKE,
  SELECT_COMMON_STOCKTAKE,
  DELETE_COMMON_STOCKTAKE,
  LOADING_COMMON_STOCKTAKES,
} from "./types";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// get stocktakes
export const getStocktakes = (page) => (dispatch, getState) => {
  dispatch({ type: LOADING_COMMON_STOCKTAKES });

  let endpoint = `/common-stocktakes?page=${page}`;

  axios
    .get(BASE_URL + endpoint, tokenConfig(getState))
    .then((res) => {
      dispatch({
        type: GET_COMMON_STOCKTAKES,
        payload: res.data.data,
        pagination: {
          from: res.data.from,
          to: res.data.to,
          total: res.data.total,
          last_page: res.data.last_page,
          current_page: res.data.current_page,
        },
      });
    })
    .catch((err) => console.error(err));
};

// select stocktake
export const selectStocktake = (stocktake) => (dispatch) => {
  dispatch({
    type: SELECT_COMMON_STOCKTAKE,
    payload: stocktake,
  });
};

// add stocktake
export const addStocktake = (payload) => (dispatch, getState) => {
  let endpoint = BASE_URL + `/common-stocktakes/`;

  axios
    .post(endpoint, payload, tokenConfig(getState))
    .then((res) => {
      swal({
        title: "Stocktake Added!",
        icon: "success",
      });
      dispatch({ type: ADD_COMMON_STOCKTAKE, payload: res.data });
    })
    .catch((err) => console.error(err));
};

// delete stocktake
export const deleteStocktake = (id) => (dispatch, getState) => {
  axios
    .delete(BASE_URL + `/common-stocktakes/${id}`, tokenConfig(getState))
    .then((res) => {
      dispatch({
        type: DELETE_COMMON_STOCKTAKE,
        payload: id,
      });
      swal({
        title: "Stocktake Deleted!",
        icon: "success",
      });
    })
    .catch((err) => console.error(err));
};
